export const buildDoorPanels = ({ x, width, standard, masterSide = "left" }) => {
  const overlapPx = 4;
  if (standard !== "double") {
    return [{ x, width, direction: standard === "single_left" ? "left" : "right", isMaster: true }];
  }
  return [
    { x, width: (width - 2) / 2 + (masterSide === "left" ? overlapPx : 0), direction: "left", isMaster: masterSide === "left" },
    { x: x + (width + 2) / 2 - (masterSide === "right" ? overlapPx : 0), width: (width - 2) / 2 + (masterSide === "right" ? overlapPx : 0), direction: "right", isMaster: masterSide === "right" },
  ];
};

export const HandleGlyph = ({ type, x, y, w, h, color = "#111", finishColor, direction }) => {
  const stroke = finishColor || color;
  // TIP-ON / push-to-open : aucune poignée visible (mécanisme intégré, cohérent avec le rendu 3D).
  if (type === "push") return null;
  if (type === "profil_line" || type === "profil_alu") {
    return (
      <g transform={`translate(${x}, ${y + 4})`}>
        <rect x={2} y={0} width={w - 4} height={2.5} rx={1.2} fill={stroke} />
        <rect x={2} y={0} width={w - 4} height={0.8} rx={0.4} fill="#FFFFFF" opacity={0.45} />
        <rect x={2} y={1.8} width={w - 4} height={0.7} rx={0.35} fill="#000000" opacity={0.2} />
      </g>
    );
  }
  if (type === "recto_verso") {
    // Poignée recto-verso : barrette pontée (bar + 2 pieds courts), vue de face
    const barY = y + h * 0.42;
    const barW = w - 6;
    return (
      <g transform={`translate(${x + 3}, ${barY})`}>
        <rect x={-0.5} y={-4} width={2} height={9} rx={0.8} fill={stroke} />
        <rect x={barW - 1.5} y={-4} width={2} height={9} rx={0.8} fill={stroke} />
        <rect x={0} y={-1.6} width={barW} height={3.2} rx={1.5} fill={stroke} />
        <rect x={0} y={-1.6} width={barW} height={1} rx={0.5} fill="#FFFFFF" opacity={0.4} />
      </g>
    );
  }
  if (type === "stripe") {
    // Poignée STRIPE : barrette légèrement cintrée (arc)
    const cy = y + h * 0.42;
    const barW = w - 8;
    const d = `M ${x + 4} ${cy} Q ${x + 4 + barW / 2} ${cy - 3} ${x + 4 + barW} ${cy}`;
    return (
      <g>
        <path d={d} fill="none" stroke={stroke} strokeWidth={2.6} strokeLinecap="round" />
        <path d={d} fill="none" stroke="#FFFFFF" strokeOpacity={0.35} strokeWidth={0.9} strokeLinecap="round" />
      </g>
    );
  }
  if (type === "etrier_square") {
    const cx = w * 0.85;
    const barH = Math.min(h * 0.35, 22);
    return (
      <g transform={`translate(${x}, ${y + h / 2 - barH / 2})`}>
        <rect x={cx - 1.4} y={0} width={2.8} height={barH} rx={0.5} fill={stroke} />
        <rect x={cx - 1.4} y={0} width={1} height={barH} rx={0.5} fill="#FFFFFF" opacity={0.4} />
        <rect x={cx - 1.4} y={-1} width={2.8} height={3} fill={stroke} />
        <rect x={cx - 1.4} y={barH - 2} width={2.8} height={3} fill={stroke} />
      </g>
    );
  }
  if (type === "bouton_cyl") {
    const cx = w * 0.85;
    return (
      <g transform={`translate(${x}, ${y + h / 2})`}>
        <circle cx={cx} cy={0} r={3} fill={stroke} stroke="rgba(0,0,0,0.3)" strokeWidth={0.6} />
        <circle cx={cx - 0.9} cy={-0.9} r={1.1} fill="rgba(255,255,255,0.7)" />
        <circle cx={cx + 0.6} cy={0.9} r={0.6} fill="rgba(0,0,0,0.25)" />
      </g>
    );
  }
  /* Béquille classique (poignée de porte de maison) : rosette circulaire + levier horizontal.
     Le levier s'étend vers l'intérieur de la porte (côté opposé aux charnières). */
  if (type === "bequille") {
    const isRight = direction === "right";  // charnière à droite → poignée à gauche
    const hx = isRight ? w * 0.18 : w * 0.82;
    const hy = h * 0.44;
    const rosR = Math.min(6.5, w * 0.10);
    const leverLen = Math.min(20, w * 0.28);
    const leverDir = isRight ? 1 : -1;  // +1 = extends right, -1 = extends left
    return (
      <g transform={`translate(${x}, ${y})`} data-testid="handle-bequille-2d">
        {/* Rosette (platine circulaire) */}
        <circle cx={hx} cy={hy} r={rosR} fill={stroke} opacity={0.90} />
        <circle cx={hx} cy={hy} r={rosR * 0.65} fill="none" stroke="rgba(255,255,255,0.4)" strokeWidth={0.6} />
        {/* Levier */}
        <line x1={hx} y1={hy} x2={hx + leverDir * leverLen} y2={hy + 2} stroke={stroke} strokeWidth={3.2} strokeLinecap="round" />
        <line x1={hx + leverDir * 0.5} y1={hy - 0.8} x2={hx + leverDir * (leverLen - 0.5)} y2={hy + 1.2} stroke="rgba(255,255,255,0.38)" strokeWidth={0.8} strokeLinecap="round" />
        {/* Embout arrondi du levier */}
        <circle cx={hx + leverDir * leverLen} cy={hy + 2} r={2.2} fill={stroke} />
        <circle cx={hx + leverDir * leverLen + leverDir * (-0.6)} cy={hy + 1.3} r={0.8} fill="rgba(255,255,255,0.5)" />
      </g>
    );
  }
  return null;
};

export const SvgTrashButton = ({ x, y, onClick, visible = true, testId }) => {
  if (!visible) return null;
  return <g transform={`translate(${x}, ${y})`} style={{ cursor: "pointer", pointerEvents: "all" }} data-testid={testId} data-svg-element onPointerDown={(event) => { event.stopPropagation(); event.preventDefault(); }} onPointerUp={(event) => { event.stopPropagation(); event.preventDefault(); }} onClick={(event) => { event.stopPropagation(); event.preventDefault(); onClick?.(); }}><circle cx={0} cy={0} r={9} fill="#DC2626" stroke="#FFF" strokeWidth={1.5} /><path d="M-3.5 -3 L3.5 3 M3.5 -3 L-3.5 3" stroke="#FFF" strokeWidth={1.6} strokeLinecap="round" /></g>;
};

export const SvgDuplicateButton = ({ x, y, onClick, visible = true, testId }) => {
  if (!visible) return null;
  return <g transform={`translate(${x}, ${y})`} style={{ cursor: "pointer", pointerEvents: "all" }} data-testid={testId} data-svg-element onPointerDown={(event) => { event.stopPropagation(); event.preventDefault(); }} onPointerUp={(event) => { event.stopPropagation(); event.preventDefault(); }} onClick={(event) => { event.stopPropagation(); event.preventDefault(); onClick?.(); }}><circle cx={0} cy={0} r={9} fill="#0465C1" stroke="#FFF" strokeWidth={1.5} /><rect x={-3.6} y={-3.6} width={5.4} height={5.4} rx={0.8} fill="none" stroke="#FFF" strokeWidth={1.3} /><rect x={-1.6} y={-1.6} width={5.4} height={5.4} rx={0.8} fill="#0465C1" stroke="#FFF" strokeWidth={1.3} /></g>;
};

/**
 * Cluster d'actions (dupliquer + supprimer) CENTRÉ directement sur la façade d'un élément
 * (tiroir/penderie/tablette), au lieu d'une croix isolée sur le bord qui entrait en conflit
 * avec les boutons d'extension/réduction de tiroir traversant (bugs de clic signalés).
 */
export const ElementActionCluster = ({ cx, cy, onDuplicate, onRemove, visible = true, elId }) => {
  if (!visible) return null;
  return (
    <g>
      {onDuplicate && <SvgDuplicateButton x={cx - 12} y={cy} onClick={onDuplicate} testId={`duplicate-${elId}`} />}
      {onRemove && <SvgTrashButton x={cx + 12} y={cy} onClick={onRemove} testId={`trash-${elId}`} />}
    </g>
  );
};

export const DoorHingeCue = ({ x, y, w, h, direction, dark, testId }) => {
  const hingeX = direction === "left" ? x + 3 : x + w - 3;
  const closingX = direction === "left" ? x + w - 4 : x + 4;
  const centerY = y + h / 2;
  const cueColor = dark ? "rgba(255,255,255,0.78)" : "rgba(17,24,39,0.74)";
  return <g data-testid={testId} pointerEvents="none" fill="none" stroke={cueColor} strokeLinecap="round" strokeLinejoin="round"><line x1={hingeX} x2={hingeX} y1={y + 7} y2={y + h - 7} strokeWidth="1.9" /><circle cx={hingeX} cy={y + 6} r="2.4" fill={cueColor} stroke="none" /><circle cx={hingeX} cy={y + h - 6} r="2.4" fill={cueColor} stroke="none" /><polyline points={`${hingeX},${y + 4} ${closingX},${centerY} ${hingeX},${y + h - 4}`} strokeWidth="1.8" strokeDasharray="5 3" /><line x1={closingX} x2={closingX} y1={centerY - 8} y2={centerY + 8} strokeWidth="2.4" /></g>;
};

export const DoorPlacementPreview = ({ sectionIndex, panels, y, height, doorFill, grainId, dark }) => <g data-testid={`door-drop-target-${sectionIndex}`} pointerEvents="none"><title data-testid="door-drop-target-label">Aperçu de porte complète</title>{panels.map((panel, panelIndex) => <g key={`door-preview-${sectionIndex}-${panelIndex}`} data-testid={`door-preview-leaf-${sectionIndex}-${panelIndex}`}><rect x={panel.x + 1} y={y + 2} width={panel.width} height={height} fill="rgba(0,0,0,0.12)" rx={3} /><rect x={panel.x} y={y} width={panel.width} height={height} fill={doorFill} opacity={0.30} rx={3} /><rect x={panel.x} y={y} width={panel.width} height={height} fill={`url(#${grainId})`} opacity={0.09} rx={3} /><rect x={panel.x} y={y} width={panel.width} height={height} fill="none" stroke={dark ? "rgba(255,255,255,0.6)" : "rgba(0,0,0,0.65)"} strokeWidth={2.5} rx={3} /><rect x={panel.x + 5} y={y + 5} width={Math.max(0, panel.width - 10)} height={Math.max(0, height - 10)} fill="none" stroke={dark ? "rgba(255,255,255,0.3)" : "rgba(0,0,0,0.3)"} strokeWidth={1.2} rx={2} /><DoorHingeCue x={panel.x} y={y} w={panel.width} h={height} direction={panel.direction} dark={dark} testId={`door-preview-marker-${sectionIndex}-${panelIndex}`} /></g>)}</g>;